'use client'

import { Select } from 'antd'
import { useLocale, useTranslations } from 'next-intl'
import { usePathname, useRouter } from '@/navigation'
import { UPSERT_USER_LOCALE } from '@/graphql/mutations/upsertLocale'
import { useMutation } from '@apollo/client'
import { useDispatch } from 'react-redux'
import { updateInformations } from '@/reducers/societyInformations'
import { useEffect } from 'react'
import { locales } from '@/i18n/request'
import { Locale } from '@/types/locale'

const CountryLangSelector = () => {
  const t = useTranslations()
  const local = useLocale()
  const pathname = usePathname()
  const router = useRouter()
  const dispatch = useDispatch()

  const [upsertUserLocale] = useMutation(UPSERT_USER_LOCALE)

  const options = locales.map((lang) => {
    return { label: t(`common.${lang}`), value: lang }
  })

  const handleChange = (value: string) => {
    upsertUserLocale({ variables: { locale: value.toUpperCase() } })
    window.kameleoonQueue?.push(['Goals.processConversion', 343663])
    router.replace(pathname, { locale: value as Locale })
  }

  useEffect(() => {
    dispatch(updateInformations({ locale: local.toUpperCase() }))
  }, [])

  return (
    <Select
      data-testid='country-lang-selector'
      options={options}
      variant='borderless'
      defaultValue={local}
      onChange={handleChange}
      styles={{
        popup: {
          root: {
            width: 'fit-content'
          }
        }
      }}
    />
  )
}

export default CountryLangSelector
